export const formatPrice = (
  value: number | string,
  withCurrency = true,
): string => {
  const price = new Intl.NumberFormat('ru-RU').format(+value)
  return price + (withCurrency ? ' ₽' : '')
}

// преобразование цены из значения в копейках в рубли
export function formatPriceInRubles(price: number) {
  const priceInRubles = (price / 100).toFixed(2)
  const formattedPrice = priceInRubles.replace(/\.00$/, '')
  return `${formattedPrice.toLocaleString()} ₽`
}
